var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.pricings == null ? _c('div', {
    staticClass: "text-center p-5"
  }, [_c('h5', [_vm._v("Loading...")])]) : _vm._e(), _vm.pricings ? _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t("index")))]), _c('th', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t("product")))]), _c('th', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t("description")))]), _c('th', {
    staticClass: "text-center",
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t("org.nav3")) + " (RM)")]), _c('th', {
    staticClass: "text-center",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.$t("share")) + " (RM)")]), ['Staff', 'Super Admin'].includes(_vm.userRole) ? _c('th', {
    staticClass: "text-center",
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("amendment-price")) + " (RM) ")]) : _vm._e(), ['Staff', 'Super Admin'].includes(_vm.userRole) ? _c('th', {
    staticClass: "text-center",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("sharing-amendments")) + " (RM) ")]) : _vm._e(), _c('th', {
    staticClass: "text-center",
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t("date")))]), _c('th', {
    staticClass: "text-center",
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t("status")))]), ['Staff'].includes(_vm.userRole) ? _c('th', {
    staticClass: "text-center",
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("action")) + " ")]) : _vm._e()]), _c('tr', [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("AWARIS")]), ['Staff', 'Super Admin'].includes(_vm.userRole) ? _c('th', [_vm._v(" " + _vm._s(_vm.$t("business-partner")) + " ")]) : _vm._e(), _vm.userRole == 'Staff' ? _c('th', {
    staticClass: "text-center"
  }, [_vm._v("POSSB")]) : _vm._e(), ['Staff', 'Super Admin'].includes(_vm.userRole) ? _c('th', {
    staticClass: "text-center"
  }, [_vm._v(" AWARIS ")]) : _vm._e(), ['Staff', 'Super Admin'].includes(_vm.userRole) ? _c('th', {
    staticClass: "text-center"
  }, [_vm._v(" " + _vm._s(_vm.$t("business-partner")) + " ")]) : _vm._e(), ['Staff'].includes(_vm.userRole) ? _c('th', {
    staticClass: "text-center"
  }, [_vm._v(" POSSB ")]) : _vm._e()])]), _c('tbody', [_vm.pricings.length == 0 ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "9"
    }
  }, [_c('h5', {
    staticClass: "m-5"
  }, [_vm._v(_vm._s(_vm.$t("pricing.no-info")))])])]) : _vm._e(), _vm._l(_vm.pricings, function (pricing, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _c('td', [_vm._v(_vm._s(pricing.product))]), _c('td', [_vm._v(_vm._s(pricing.description))]), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(pricing.price))]), _vm.userRole == 'Staff' ? _c('td', {
      staticClass: "text-center"
    }, [_vm._v(" " + _vm._s(pricing.awaris_share) + " ")]) : _vm._e(), _vm.organizationType != 'Awaris' && _vm.userRole != 'Staff' ? _c('td', {
      staticClass: "text-center"
    }, [_vm._v(" " + _vm._s(pricing.awaris_share + pricing.prooffice_share) + " ")]) : _vm._e(), ['Staff', 'Super Admin'].includes(_vm.userRole) ? _c('td', {
      staticClass: "text-center"
    }, [_vm._v(" " + _vm._s(pricing.organization_share) + " ")]) : _vm._e(), _vm.userRole == 'Staff' ? _c('td', {
      staticClass: "text-center"
    }, [_vm._v(" " + _vm._s(pricing.prooffice_share) + " ")]) : _vm._e(), ['Staff', 'Super Admin'].includes(_vm.userRole) ? _c('td', {
      staticClass: "text-center"
    }, [_vm._v(" " + _vm._s(pricing.amendment_price) + " ")]) : _vm._e(), _vm.userRole == 'Staff' ? _c('td', {
      staticClass: "text-center"
    }, [_vm._v(" " + _vm._s(pricing.amendment_awaris_share) + " ")]) : _vm._e(), _vm.organizationType != 'Awaris' && _vm.userRole != 'Staff' ? _c('td', {
      staticClass: "text-center"
    }, [_vm._v(" " + _vm._s(pricing.amendment_awaris_share + pricing.amendment_prooffice_share) + " ")]) : _vm._e(), ['Staff', 'Super Admin'].includes(_vm.userRole) ? _c('td', {
      staticClass: "text-center"
    }, [_vm._v(" " + _vm._s(pricing.amendment_organization_share) + " ")]) : _vm._e(), _vm.userRole == 'Staff' ? _c('td', {
      staticClass: "text-center"
    }, [_vm._v(" " + _vm._s(pricing.amendment_prooffice_share) + " ")]) : _vm._e(), _c('td', {
      staticClass: "text-center"
    }, [_c('small', [_vm._v(_vm._s(_vm._f("formatDateTime")(pricing.created_at)))])]), _c('td', {
      staticClass: "text-center"
    }, [pricing.status == 1 ? _c('span', {
      staticClass: "badge badge-success"
    }, [_vm._v(_vm._s(_vm.$t("active")))]) : _vm._e(), pricing.status != 1 ? _c('span', {
      staticClass: "badge badge-warning"
    }, [_vm._v(_vm._s(_vm.$t("inactive")))]) : _vm._e()]), _c('td', {
      staticClass: "text-center"
    }, [['Staff'].includes(_vm.userRole) ? _c('router-link', {
      staticClass: "btn btn-primary btn-sm",
      attrs: {
        "to": {
          name: 'organization.pricing.info',
          params: {
            organization_id: _vm.organizationId,
            pricing_id: pricing.id
          }
        }
      }
    }, [_c('img', {
      attrs: {
        "src": "/images/icon/view.svg",
        "height": "22px",
        "alt": ""
      }
    })]) : _vm._e()], 1)]);
  })], 2)])]) : _vm._e(), _c('hr'), _c('div', {
    staticClass: "text-center"
  }, [['Staff'].includes(_vm.userRole) ? _c('router-link', {
    staticClass: "btn btn-primary",
    attrs: {
      "to": {
        name: 'organization.pricing.create'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("pricing.add-price")))]) : _vm._e()], 1), _c('div', {
    staticClass: "row mt-4"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('b-pagination', {
    attrs: {
      "total-rows": _vm.pagination.totalRows,
      "per-page": _vm.pagination.perPage,
      "aria-controls": "my-table"
    },
    on: {
      "change": _vm.pageClicks
    },
    model: {
      value: _vm.pagination.currentPage,
      callback: function ($$v) {
        _vm.$set(_vm.pagination, "currentPage", $$v);
      },
      expression: "pagination.currentPage"
    }
  })], 1), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form custom-form"
  }, [_c('div', {
    staticClass: "form-group mb-0"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.pagination.perPage,
      expression: "pagination.perPage"
    }],
    staticClass: "form-control custom-select",
    attrs: {
      "id": "Sortbylist-job"
    },
    on: {
      "change": [function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.pagination, "perPage", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }, function ($event) {
        return _vm.changePerPage();
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("10 " + _vm._s(_vm.$t("per-page")))]), _c('option', {
    attrs: {
      "value": "25"
    }
  }, [_vm._v("25 " + _vm._s(_vm.$t("per-page")))]), _c('option', {
    attrs: {
      "value": "50"
    }
  }, [_vm._v("50 " + _vm._s(_vm.$t("per-page")))])])])])])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }